import { render, staticRenderFns } from "./CommunitySignup.vue?vue&type=template&id=3d3612b4&scoped=true"
import script from "./CommunitySignup.vue?vue&type=script&lang=js"
export * from "./CommunitySignup.vue?vue&type=script&lang=js"
import style0 from "./CommunitySignup.vue?vue&type=style&index=0&id=3d3612b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3612b4",
  null
  
)

export default component.exports